import React from 'react';
import { Input } from './Input';
import { FormError } from '../types/ErrorResponse.type';

type Props = {
  name: string;
  className?: string;
  label?: string;
  value?: string | number;
  onChange?: (val: any) => void;
  errors?: FormError;
  disabled?: boolean;
  placeholder?: string;
  hint?: string | JSX.Element;
  hintOnClick?: () => void;
};

export const PriceInput: React.FC<Props> = ({
  value,
  onChange,
  ...props
}) => {
  const handleChange = (val: string) => {
    // Remove any non-numeric characters except decimal point
    let cleaned = val.replace(/[^\d.]/g, '');
    
    // Handle multiple decimal points - keep only the first one
    const parts = cleaned.split('.');
    if (parts.length > 2) {
      cleaned = parts[0] + '.' + parts.slice(1).join('');
    }
    
    // Limit to 2 decimal places
    if (parts.length === 2 && parts[1].length > 2) {
      cleaned = parts[0] + '.' + parts[1].substring(0, 2);
    }
    
    // Pass the cleaned value directly to parent
    onChange?.(cleaned);
  };

  return (
    <Input
      {...props}
      value={value}
      onChange={handleChange}
      type="text"
      inputMode="decimal"
    />
  );
};